import { render, staticRenderFns } from "./NavBarClient.vue?vue&type=template&id=0477d292"
import script from "./NavBarClient.vue?vue&type=script&lang=js"
export * from "./NavBarClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports